import React from "react";
import { HStack, VStack, Button, Text, Flex } from "@chakra-ui/react";
import { DatePicker, Form, Select, TextInput } from "components";
import { casesActions } from "configs";
import { useCurrentCase, useDispatch } from "duck";
import {
  getValidation,
  QUALITY_OF_RECOVERY_OPTIONS,
  useUpdateVitalComment
} from "./duck";

const CommentsSection: React.FC = () => {
  const dispatch = useDispatch();

  const { comments, procedures, caseId } = useCurrentCase(medicalCase => ({
    comments: medicalCase.data.client?.patient?.vitalComment,
    procedures: medicalCase.data.client?.patient?.patientProcedures,
    caseId: medicalCase.data._id
  }));
  const anesthesia = procedures?.find(
    procedure => procedure.name === "Anesthesia"
  );

  const validation = React.useMemo(() => getValidation(comments), [comments]);

  const update = useUpdateVitalComment(comments?._id);

  if (!comments) {
    return null;
  }

  return (
    <Form {...validation}>
      {({ setValue }) => (
        <>
          <Form.Watcher
            defaultValues={validation.defaultValues}
            onChange={update}
          />
          <VStack spacing={4} alignItems="left">
            <TextInput
              type="text-area"
              name="comments"
              label="Comments and additional drugs"
              placeholder="Comments and additional drugs"
            />
            <HStack spacing={4}>
              {comments.timeExtubation ? (
                <DatePicker
                  name="timeExtubation"
                  label="Time of extubation"
                  showTimeSelect
                  showTimeSelectOnly
                  placeholderText="Time of extubation"
                  dateFormat="h:mm aa"
                />
              ) : (
                <Flex direction="column" w="100%">
                  <Text mb={2}>Time of extubation</Text>
                  <Button
                    w="fit-content"
                    onClick={() => {
                      const timeExtubation = new Date();
                      setValue("timeExtubation", timeExtubation);

                      if (
                        anesthesia &&
                        anesthesia.startTime &&
                        !anesthesia.endTime
                      ) {
                        dispatch(
                          casesActions.updatePatientProcedure({
                            data: {
                              endTime: timeExtubation.toISOString(),
                              ...(anesthesia._id
                                ? { _id: anesthesia._id }
                                : { fakeId: anesthesia.fakeId })
                            },
                            _id: caseId
                          })
                        );
                      }
                    }}
                  >
                    Now
                  </Button>
                </Flex>
              )}

              <Select
                name="qualityRecovery"
                label="Quality of recovery"
                placeholder="Quality of recovery"
                options={QUALITY_OF_RECOVERY_OPTIONS}
              />
            </HStack>
          </VStack>
        </>
      )}
    </Form>
  );
};

export default CommentsSection;
